import { Link } from 'react-router-dom';
import BrandWordmark from '@/components/brand/BrandWordmark';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-slate-700 bg-slate-900/50 py-6">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
          {/* Left: Logo and copyright */}
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-4 md:justify-start">
            <BrandWordmark darkText={false} className="text-lg opacity-60" />
            <p className="text-sm text-slate-400 text-center md:text-left">
              © {currentYear} ThreadLock. All rights reserved.
            </p>
          </div>

          {/* Right: Links */}
          <nav className="flex flex-wrap items-center justify-center gap-3 sm:gap-5" aria-label="Footer navigation">
            <Link
              to="/privacy"
              className="text-sm text-slate-400 transition hover:text-orange-400"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-sm text-slate-400 transition hover:text-orange-400"
            >
              Terms of Service
            </Link>
            <Link
              to="/legal-disclaimer"
              className="text-sm text-slate-400 transition hover:text-orange-400 font-medium"
            >
              Legal Disclaimer
            </Link>
            <Link
              to="/help"
              className="text-sm text-slate-400 transition hover:text-orange-400"
            >
              Help Center
            </Link>
            <a
              href="https://threadlock.ai"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-slate-400 transition hover:text-orange-400"
            >
              About ThreadLock
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
